import { Language } from '@models/Language'
import { Level } from '@models/Level'
import { Bulletin } from '@models/bulletin/Bulletin'
import { Dayjs } from 'dayjs'
import { AvailableLanguage } from '@helpers/language/AvailableLanguages'
import Constants from '@helpers/Constants'
import api from '..'
import { ModelDatesDTO } from '@models/api/bulletin/ModelDatesDTO'
import { Model } from '@models/Model'
import { RelativeDateDTO } from '@models/api/time/RelativeDateDTO'
import { Position } from '@models/map/Position'

export const fileGenerator = {
  getBulletinPDFUrl: (bulletinID: Bulletin['id'], position?: Position) => {
    let url = ''
    if (Constants.isLocalFileGeneratorActive) {
      url = api.fileGeneratorLocal.getBulletinPDFUrl(bulletinID, position)
    } else
      url = `${Constants.apiURL}/${api.bulletinConfiguration.getBulletinPDFUrl(bulletinID, position)}`

    return url
  },

  downloadBulletinPDF: async (bulletinID: Bulletin['id']) => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.downloadBulletinPDF(bulletinID)
    }
    return api.bulletinConfiguration.downloadBulletinPDF(bulletinID)
  },

  getLevelDates: async (levelID: Level['id']): Promise<ModelDatesDTO> => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.getLevelDatesLocal(levelID)
    }
    return api.bulletinConfiguration.getLevelAvailableDates(levelID)
  },

  downloadMapImage: async (
    bulletinID: Bulletin['id'],
    levelID: Level['id'],
    mapDate: Dayjs,
    isWindActive: boolean = false
  ) => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.getBulletinImageLocal(
        bulletinID,
        levelID,
        mapDate,
        isWindActive
      )
    }
    return api.bulletinConfiguration.downloadMapImage(
      bulletinID,
      levelID,
      mapDate,
      isWindActive
    )
  },

  getLegendImage: async (
    levelID: Level['id'],
    language: Language['code'] = AvailableLanguage.ES
  ) => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.getLegendImageLocal(levelID, language)
    }
    return api.bulletinConfiguration.downloadLegendImage(levelID, language)
  },

  downloadChartImage: async (
    bulletinID: Bulletin['id'],
    levelID: Level['id'],
    relativeDate: RelativeDateDTO
  ) => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.downloadChartImageLocal(
        bulletinID,
        levelID,
        relativeDate
      )
    }
    return api.bulletinConfiguration.downloadChartImage(
      bulletinID,
      levelID,
      relativeDate
    )
  },

  downloadTephigramImage: async (
    bulletinID: Bulletin['id'],
    modelID: Model['id'],
    date: Dayjs
  ) => {
    if (Constants.isLocalFileGeneratorActive) {
      return api.fileGeneratorLocal.downloadTephigramImageLocal(
        bulletinID,
        modelID,
        date
      )
    }
    return api.bulletinConfiguration.downloadTephigramImage(
      bulletinID,
      modelID,
      date
    )
  }
}
